import React, { useState } from 'react';
import {
  Container,
} from '@mui/material';

import {
  pdfjs,
  Document,
  Page,
} from 'react-pdf';

const devMode = process.env.REACT_APP_DEVMODE;
const pdfWorkerBaseUrl = devMode === 'true' ? window.location.origin : process.env.REACT_APP_BACKEND;
pdfjs.GlobalWorkerOptions.workerSrc = `${pdfWorkerBaseUrl}/pdf.worker.min.js?v=1`;

type Props = {
  pdfUrl: string;
  onLoadSuccess?: (val: boolean) => void;
  onError: (val: boolean) => void;
};

const PdfViewer: React.FC<Props> = ({
  pdfUrl,
  onLoadSuccess,
  onError,
}: Props) => {
  const [numPages, setNumPages] = useState<number>();

  const onDocumentLoadSuccess = ({ numPages: np }: { numPages: number }) => {
    setNumPages(np);
    if (onLoadSuccess) {
      onLoadSuccess(true);
    }
  };

  return (
    <Container maxWidth="sm">
      <Document
        file={pdfUrl}
        onLoadSuccess={onDocumentLoadSuccess}
        onLoadError={() => onError(true)}
      >
        {Array.from(
          new Array(numPages),
          (el, index) => (
            <Page
              key={`page_${index + 1}`}
              pageNumber={index + 1}
            />
          ),
        )}
      </Document>
    </Container>
  );
};

export default PdfViewer;
